import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { TestType } from '@/domain/value_objects/judge/TestType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { PostSubmissionModuleName, PostTestSubmissionModuleName } from '@/store/modules/modules'

export class PostTestSubmissionViewModel {
  private store = useStore()

  judgeToken: ComputedRef<string> = computed(() => this.store.getters[`${PostSubmissionModuleName}/judgeToken`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${PostSubmissionModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${PostSubmissionModuleName}/error`])

  async postTestSubmission(
    problemId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string,
    type: TestType
  ): Promise<void> {
    await this.store.dispatch(`${PostTestSubmissionModuleName}/postTestSubmission`, {
      problemId,
      programLanguage,
      sourceCode,
      type
    })
  }
}
